"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = requiredTrue;

function requiredTrue(value) {
  if (value !== true) {
    return {
      message: 'validation.required'
    };
  }

  return null;
}